export default function WaitingScreen({ waitingText }) {
	var waiting_svg = 'asset/widget/AW_waiting_grey.svg';
	return (
		<div className='relative flex flex-grow flex-col items-center justify-center'>
			<div className='flex h-[200px] w-[200px] items-center justify-center'>
				<img
					className='h-[120px] w-[120px] animate-breathingPulse'
					src={waiting_svg}
					alt='Loading animation'
					loading='eager'
				/>
			</div>
			<div>
				<br></br>
				<p className='m-0 text-center font-bold text-white'>{waitingText}</p>
			</div>
		</div>
	);
}
